<template>
  <div v-if="product && languageCode">
    <div
      class="row mt-3"
    >
      <div class="col-md-12 content-list mb-2">
        <b>Airport Name:</b>
        <span>{{ airportName }}</span>
      </div>
      <div
        v-if="terminalName"
        class="col-md-12 content-list mb-2"
      >
        <b>Terminal Name:</b>
        <span>{{ terminalName }}</span>
      </div>
      <div class="col-md-12 content-list mb-2">
        <b>{{ firstOptionLabel }} Date:</b>
        <span v-if="!editModeValue">{{ localDateTime(product.entryDate) }}</span>
        <span v-if="editModeValue">{{ localDateTime(product.entryDate) }} &nbsp;
          <input
            v-if="editModeValue"
            v-model="entryTime"
            :class="{ 'is-invalid': $v.entryTime.$invalid}"
            class="form-control col-4"
          >
        </span>
      </div>
      <div
        v-if="bookingType !== 2"
        class="col-md-12 content-list mb-2"
      >
        <b>{{ secondOptionLabel }} Date:</b>
        <span v-if="!editModeValue">{{ localDateTime(product.exitDate) }}</span>
        <span v-if="editModeValue">{{ localDateTime(product.exitDate) }} &nbsp;
          <input
            v-if="editModeValue"
            v-model="exitTime"
            :class="{ 'is-invalid': $v.exitTime.$invalid}"
            class="form-control col-4"
          >
        </span>
      </div>
      <div class="row w-100 mb-2">
        <button
          v-if="editModeValue"
          :disabled="updateInProgress"
          class="btn btn-secondary mt-1 mx-2 col btn-block"
          @click="editModeValue = !editModeValue"
        >
          Cancel <i class="icon--cross" />
        </button>
        <button
          v-if="editModeValue"
          :disabled="$v.$invalid || updateInProgress"
          class="btn btn-primary mt-1 mx-2 col btn-block"
          @click="saveProduct"
        >
          Save <i class="icon--floppy-disk" />
        </button>
      </div>
      <div
        v-if="bookingType === 1"
        class="col-md-12 content-list mb-2"
      >
        <b>Product:</b>
        <span>{{ product.name }}</span>
      </div>

      <div
        v-if="bookingType === 1"
        class="col-md-12 content-list mb-2"
      >
        <b>Price:</b>
        <span>{{ $n(product.productPrice, 'currency', languageCode) }}</span>
      </div>

      <div
        v-if="bookingType === 1 && (productOverridePrice != product.productPrice)"
        class="col-md-12 content-list mb-2"
      >
        <b>Override Price:</b>
        <span>{{ $n(productOverridePrice, 'currency', languageCode) }}</span>
      </div>
      <div
        v-if="product.bundleId !== null"
        class="col-md-12"
      >
        <Extra
          v-for="(extra, index) in product.extras"
          :key="index"
          :extra="extra"
          :bundled="true"
          class="product-add-ons"
        />
      </div>

      <div class="col-md-12 content-list mb-2">
        <b>Promo Code:</b>
        <span>{{ product.promoCode }} <div
          v-if="!product.promoCode"
        >(No code used)</div> </span>
      </div>
    </div>

    <div class="row">
      <div
        v-if="productExtras.length > 0"
        class="col-md-12 mt-3 product-extras"
      >
        <b v-if="bookingType === 1">Add ons:</b>
        <b v-else>Products:</b>
        <Extra
          v-for="(extra, index) in productExtras"
          :key="index"
          :extra="extra"
          class="mb-2 mt-3 product-add-ons"
        />
      </div>
      <div
        v-if="product.originalTotalPrice !== product.totalPrice"
        class="col-md-12 content-list mb-2"
      >
        <b>Original Total Price :</b>
        <span>{{ $n(product.originalTotalPrice, 'currency', languageCode) }}</span>
      </div>
      <div
        v-if="product.originalTotalPrice !== product.totalPrice"
        class="col-md-12 content-list mb-2"
      >
        <b>Promotion Saving :</b>
        <span>{{ $n(product.promotionSaving, 'currency', languageCode) }}</span>
      </div>
      <div class="col-md-12 content-list mb-2 mt-3 price-total">
        <b>Total:</b>
        <span>{{ $n(product.totalPrice, 'currency', languageCode) }}</span>
      </div>
      <div v-if="product.bookingFee > 0"
            class="col-md-12 content-list mb-3">
            Includes {{$n(product.bookingFee, 'currency', languageCode)}} booking fee
      </div>
      <div
        v-if="refundedAmount && (refundedAmount !== product.totalPrice)"
        class="col-md-12 content-list mb-2"
      >
        <b>Total Refunded:</b>
        <span>{{ $n(refundedAmount, 'currency', languageCode) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import Extra from './Extra'
var moment = require('moment')
const timeValidater = (value) => /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/.test(value)

export default {
    name: 'Product',
    components: {
        Extra
    },
    props: {
        editMode: {
            default: false
        },
        firstOptionLabel: {
            default: 'Entry'
        },
        secondOptionLabel: {
            default: 'Exit'
        }
    },
    data () {
        return {
            entryTime: null,
            exitTime: null,
            updateInProgress: false
        }
    },
    computed: {
        editModeValue: {
            get: function () {
                return this.editMode
            },
            set: function (newValue) {
                this.$emit('update:editMode', newValue)
            }
        },
        airportName () {
            if (this.product && this.airports) {
                if (this.product.airportName) {
                    return this.product.airportName
                }
                var airports = this.airports.filter(c => c.id === this.product.airportId)
                if (airports && airports.length > 0) {
                    return airports[0].name
                }
            }
            return ''
        },
        terminalName () {
            if (this.product && this.airports && this.product.terminalId) {
                var airports = this.airports.filter(c => c.id == this.product.airportId)
                if (airports && airports.length > 0 && airports[0].terminals) {
                    var terminals = airports[0].terminals.filter(c => c.id === this.product.terminalId)
                    if (terminals && terminals.length > 0) {
                        return terminals[0].name
                    }
                }
            }
            return null
        },
        refundedAmount () {
            if (this.refundValueAvailable && this.product) {
                return this.product.totalPrice - this.refundValueAvailable
            }
            return null
        },
        productOverridePrice () {
            if (this.productExtras && this.product) {
                var extrasPrice = this.productExtras.reduce((sum, e) => {
                    sum += e.totalPrice
                    return sum
                }, 0)
                console.log("product", this.product)
                return ((this.product.totalPrice - extrasPrice) - this.product.bookingFee).toFixed(2)
            }
            return 0
        },
        ...mapState({
            product: state => state.booking.product,
            productExtras: state => state.booking.productExtras,
            bookingType: state => state.booking.bookingType,
            airports: state => state.airport.airports,
            refundValueAvailable: state => state.booking.refundDetails
        }),
        languageCode () {
            return this.$store.getters['getLanguageCode']({
                identifier: this.$store.state.airport.selectedAirportId
            })
        }
    },
    async created () {
        await this.$store.dispatch('getProduct', this.$route.params.bookingId)
        await this.$store.dispatch('getProductExtras', this.$route.params.bookingId)
        await this.$store.dispatch('getAirports')
        if (this.product !== null) {
            this.entryTime = moment(this.product.entryDate).utc().format('HH:mm')
            this.exitTime = moment(this.product.exitDate).utc().format('HH:mm')
        }
        await this.$store.dispatch('setSelectedAirportId', this.product.airportId)
    },
    validations: {
        entryTime: {
            required,
            timeValidater
        },
        exitTime: {
            required,
            timeValidater
        }
    },
    methods: {
        localDateTime(dateTime) {
            var momentDateTime = moment.utc(dateTime).format('ddd MMM DD YYYY HH:mm:ss')
            var localDateTime = moment(momentDateTime).local().format('ddd MMM DD YYYY HH:mm:ss')

            return localDateTime
        },
        async saveProduct () {
            this.updateInProgress = true
            var entryParts = this.entryTime.split(':')
            var entryDateTime = new Date(moment(this.product.entryDate).utc().hours(entryParts[0]).minutes(entryParts[1]))

            var exitParts = this.exitTime.split(':')
            var exitDateTime = new Date(moment(this.product.exitDate).utc().hours(exitParts[0]).minutes(exitParts[1]))

            if (this.entryDate < new Date()) {
                this.$toasted.error('Entry date cannot be in the past')
            } else if (this.exitDate < this.entryDate) {
                this.$toasted.error('Exit date cannot be before entry date')
            } else {
                const result = await this.$store.dispatch('updateProductDate', [this.$route.params.bookingId, entryDateTime, exitDateTime])
                if (result.status === 200 || result.status === 201) {
                    this.$toasted.success('Product details saved')
                    this.editModeValue = false
                    await this.$store.dispatch('getProduct', this.$route.params.bookingId)
                } else {
                    this.$toasted.error(`Product not updated. Error: ${result.data}`)
                }
            }
            this.updateInProgress = false
        },
        formatRawDate: function (date) {
            return moment(date).format('DD/MM/YYYY')
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
